// extracted by mini-css-extract-plugin
module.exports = {"container":"TextZodiac2_container__8gUzE","text-anal":"TextZodiac2_text-anal__16pA0"};